import { TipoArticuloApiInputProps, TipoArticuloInputProps } from '../interfaces/'

/**
 * Componemos el input a valores que acepta el servicio
 * @param input
 */
export const tipoArticuloComposeService = (input: TipoArticuloInputProps): TipoArticuloApiInputProps => {
  return {
    codigo: input.codigo,
    input: {
      descripcion: input.descripcion,
      grupoUnidadMedida: input.grupoUnidadMedida,
      notas: input.notas?.map((n) => n.value) || [],
      orden: input.orden,
    },
  }
}
